import React from 'react'
import { Form, Input, Button } from 'antd'

import { Group } from './PermissionsTypes';
import I18n from '../../i18n';

type PropsType = {
  onDefineGroupName: any,
  onToggleModal: any,
  onToggleControls: any,
  currentGroup: Group,
  canGoControls: boolean
}

class PermissionsDefineGroup extends React.Component<PropsType, any> {
  render() {
    const { canGoControls } = this.props

    return (
      <Form>
        <Form.Item label={I18n.l('permissions.createGroupModal.inputName')} className={!canGoControls ? 'group-name has-error' : 'group-name'}>
          <Input type="text" placeholder={I18n.l('permissions.createGroupModal.typeHere')} value={this.props.currentGroup.name} onChange={this.props.onDefineGroupName} />
          {!canGoControls && <div className="alert error">
            <p className="ant-form-explain">{I18n.l('permissions.createGroupModal.requiredName')}</p>
          </div>}
        </Form.Item>

        <Form.Item className="mb-0 text-right">
          <Button onClick={this.props.onToggleModal} type="link">
            {I18n.l('common.cancel')}
          </Button>

          <Button type="primary" className="ml-1" shape="round" onClick={() => this.props.onToggleControls(true)}>
            {I18n.l('common.next')}
          </Button>
        </Form.Item>
      </Form>
    )
  }
}

export default PermissionsDefineGroup